export const OFFER_TYPE_MAP = {
  hotel: 'FLASH',
  tactical_ao_hotel: 'LPC',
  rental: 'Villa',
};

export const sources = [
  { label: 'Metasearch', value: 'metasearch' },
  { label: 'Metasearch Session', value: 'metasearchSession' },
  { label: 'CUG Metasearch', value: 'cugMetasearch' },
  { label: 'Logged In Metasearch', value: 'loggedInMetasearch' },
];

export const ACTIVE_TYPES = ['tactical_ao_hotel'];
